<template>
  <li class="nav-item" :class="config.active ? 'active' : '' ">
    <router-link
      v-if="config.router"
      :to="{ name: config.link, params: {}}"
      class="nav-link"
    >{{ config.text}}</router-link>
    <a v-if="!config.router" :to="config.link" class="nav-link">{{ config.text}}</a>
  </li>
</template>

<script>
export default {
  name: 'NavItemComponent',
  props: ['config'],
  data() {
    return {
      teste: false
    };
  }
};
</script>


// WEBPACK FOOTER //
// src/components/dashboard/layout/nav/NavItem.vue